import { useState } from "react";
import { toast } from "sonner";
import { adminApi, errText } from "./api";
import { Field, SaveBtn, Panel } from "./Fields";

const FIELDS = [
  ["whatsappNumber", "WhatsApp numarası (ülke kodlu, sadece rakam)", "Örn: 905303809300 — sipariş ve test butonları bu numaraya gider"],
  ["whatsappDisplay", "WhatsApp numarası (sitede görünen)", "Örn: 0 530 380 93 00"],
  ["telegram", "Telegram bağlantısı", ""],
  ["telegramDisplay", "Telegram (sitede görünen)", ""],
  ["instagram", "Instagram bağlantısı", ""],
  ["instagramDisplay", "Instagram (sitede görünen)", ""],
];

export const ContactEditor = ({ initial, onSaved }) => {
  const [c, setC] = useState(initial);
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await adminApi.put("/admin/contact", { ...c, whatsappNumber: String(c.whatsappNumber || "").replace(/\D/g, "") });
      toast.success("İletişim bilgileri kaydedildi");
      onSaved();
    } catch (ex) {
      toast.error(errText(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={save} data-testid="admin-contact-form">
      <Panel>
        <div className="grid md:grid-cols-2 gap-5">
          {FIELDS.map(([k, label, hint]) => (
            <Field key={k} id={`contact-${k}`} label={label} hint={hint} value={c[k] || ""} required
              onChange={(e) => setC({ ...c, [k]: e.target.value })} data-testid={`admin-contact-${k}`} />
          ))}
        </div>
        <div className="mt-8"><SaveBtn busy={busy} data-testid="admin-contact-save" /></div>
      </Panel>
    </form>
  );
};
